import { useCallback, useEffect, useState } from "react"

import AssetService from "services/AssetService"
import { IApiLink } from "@/types"
import ShippingOrder from "models/ShippingOrder"
import { useUnits } from "stores/units"

interface IUseReservationShippingOrdersParams {
    linkGetShippingOrders?: IApiLink
}

export default function useReservationShippingOrders({
    linkGetShippingOrders,
}: IUseReservationShippingOrdersParams, onFail?: (e: any) => void) {
    const [shippingOrders, setShippingOrders] = useState<ShippingOrder[] | null>(null)
    const [isLoading, setIsLoading] = useState(true)
    const { units } = useUnits()

    const fetchShippingOrders = useCallback(async () => {
        if (!linkGetShippingOrders) {
            setIsLoading(false)
            return
        }

        setIsLoading(true)

        try {
            const fetchedShippingOrders = await AssetService.getReservationShippingOrders(linkGetShippingOrders, units)
            setShippingOrders(fetchedShippingOrders)
            setIsLoading(false)
        } catch (e) {
            console.error('❌ useReservationShippingOrders: Fetch failed:', e)
            if (typeof onFail === "function") {
                onFail(e)
            }
        }
    }, [linkGetShippingOrders, onFail, units])

    useEffect(() => {
        fetchShippingOrders()
    }, [fetchShippingOrders])

    return {
        refetchShippingOrders: fetchShippingOrders,
        shippingOrders,
        isLoadingShippingOrders: isLoading
    }
}
